import { render, staticRenderFns } from "./WebsiteHealthResult.vue?vue&type=template&id=23221a3e&scoped=true&"
import script from "./WebsiteHealthResult.vue?vue&type=script&lang=ts&"
export * from "./WebsiteHealthResult.vue?vue&type=script&lang=ts&"
import style0 from "./WebsiteHealthResult.vue?vue&type=style&index=0&id=23221a3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23221a3e",
  null
  
)

export default component.exports